export const FETCH_CONFIG_REQUEST = 'FETCH_CONFIG_REQUEST';
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS';
export const FETCH_CONFIG_FAILED = 'FETCH_CONFIG_FAILED';

export const FETCH_UPDATE_CONFIG_REQUEST = 'FETCH_UPDATE_CONFIG_REQUEST';
export const FETCH_UPDATE_CONFIG_SUCCESS = 'FETCH_UPDATE_CONFIG_SUCCESS';
export const FETCH_UPDATE_CONFIG_FAILED = 'FETCH_UPDATE_CONFIG_FAILED';

export const UPDATE_CONFIGURATION_PREFERENCES = 'UPDATE_CONFIGURATION_PREFERENCES';
